/* RNG Therapy – homepage pre-order rotator + Organize Play pre-release events. Needs rng-hype.js (loaded first). */
(function () {
'use strict';
var H = window.RNGHype;
if (!H) return;
var todayPT = H.todayPT, ptEpoch = H.ptEpoch, parseTime = H.parseTime, nextDay = H.nextDay, waiting = H.waiting, validDate = H.validDate, label = H.label, shortLeft = H.shortLeft, clock = H.clock, ticking = H.ticking;
function initRotator(sec) {
if (sec.dataset.rngReady) return;
sec.dataset.rngReady = '1';
var wrap = sec.querySelector('[data-slides]');
var today = todayPT();
var slides = [].slice.call(sec.querySelectorAll('[data-slide]')).filter(function (s) {
var rel = validDate(s.dataset.release) ? s.dataset.release : '', sp = validDate(s.dataset.ships) ? s.dataset.ships : '';
var end = sp && (!rel || sp > rel) ? sp : rel;
s._rel = rel; s._ships = sp; s._end = end; s._target = rel && today < rel ? rel : end;
if (end && today > end) { s.remove(); return false; }
if (waiting(rel, today)) { s.remove(); return false; }
if (!end && s.dataset.pre !== '1') { s.remove(); return false; }
return true;
});
slides.sort(function (a, b) { return (a._target || '9999') < (b._target || '9999') ? -1 : 1; });
slides.forEach(function (s) { wrap.appendChild(s); });
if (!slides.length) { if (!sec.hasAttribute('data-design')) sec.hidden = true; return; }
sec.hidden = false;
slides.forEach(function (s) {
var rel = s._rel, end = s._end, slot = s.querySelector('[data-clock]');
var eb = s.querySelector('[data-eyebrow]'), meta = s.querySelector('[data-meta]'), btn = s.querySelector('[data-cta]');
var ships = s._ships, sh = s.querySelector('[data-ships]');
if (sh) { sh.hidden = !ships; sh.textContent = ships ? 'Ships ' + label(ships, true) : ''; }
if (end && today === end) {
eb.textContent = 'Out today';
meta.textContent = (rel ? 'Released ' + label(rel, true) + ' · ' : '') + 'in stock now';
slot.innerHTML = '<p class="rng-hype-live-text">Out now</p>';
btn.textContent = 'Shop now';
} else if (s._target) {
meta.textContent = rel ? (today < rel ? 'Releases ' : 'Released ') + label(rel, true) + (today < rel && meta.dataset.extra ? ' · ' + meta.dataset.extra : '') : (meta.dataset.extra || '');
var fin = function () {
eb.textContent = 'Out today';
slot.innerHTML = '<p class="rng-hype-live-text">Out now</p>';
btn.textContent = 'Shop now';
};
clock(slot, ptEpoch(s._target, 0, 0), false).done = s._target === end ? fin : function () {
meta.textContent = 'Released ' + label(rel, true);
clock(slot, ptEpoch(end, 0, 0), false).done = fin;
};
} else {
meta.textContent = 'Release date coming soon' + (meta.dataset.extra ? ' · ' + meta.dataset.extra : '');
slot.innerHTML = '';
}
});
var nav = sec.querySelector('[data-nav]');
var i = 0, timer = null, hover = false, focusIn = false;
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var paused = reduce;
var ms = (parseInt(sec.dataset.interval, 10) || 5) * 1000;
var dots = [];
function show(n) {
slides[i].classList.remove('is-on'); slides[i].setAttribute('aria-hidden', 'true');
if (dots[i]) dots[i].setAttribute('aria-current', 'false');
i = (n + slides.length) % slides.length;
slides[i].classList.add('is-on'); slides[i].removeAttribute('aria-hidden');
if (dots[i]) dots[i].setAttribute('aria-current', 'true');
slides.forEach(function (s, k) { s.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = k === i ? 0 : -1; }); });
}
slides.forEach(function (s) { s.classList.remove('is-on'); s.setAttribute('aria-hidden', 'true'); });
slides[0].classList.add('is-on');
if (slides.length < 2) { nav.hidden = true; show(0); return; }
var pauseBtn = nav.querySelector('[data-pause]');
slides.forEach(function (s, k) {
var d = document.createElement('button');
d.type = 'button';
d.className = 'rng-hc__dot';
d.setAttribute('aria-label', 'Show pre-order ' + (k + 1) + ' of ' + slides.length + ': ' + (s.dataset.title || ''));
d.innerHTML = '<span></span>';
d.addEventListener('click', function () { show(k); sync(); });
nav.insertBefore(d, pauseBtn);
dots.push(d);
});
nav.hidden = false;
show(0);
function sync() {
if (timer) { clearInterval(timer); timer = null; }
if (!paused && !hover && !focusIn && !document.hidden) timer = setInterval(function () { show(i + 1); }, ms);
pauseBtn.classList.toggle('is-paused', paused);
pauseBtn.setAttribute('aria-label', paused ? 'Play pre-order rotation' : 'Pause pre-order rotation');
}
pauseBtn.addEventListener('click', function () { paused = !paused; if (!paused) show(i + 1); sync(); });
sec.addEventListener('mouseenter', function () { hover = true; sync(); });
sec.addEventListener('mouseleave', function () { hover = false; sync(); });
sec.addEventListener('focusin', function () { focusIn = true; sync(); });
sec.addEventListener('focusout', function () { focusIn = false; sync(); });
document.addEventListener('visibilitychange', sync);
sync();
}
function initPrerelease(sec) {
if (sec.dataset.rngReady) return;
sec.dataset.rngReady = '1';
var list = sec.querySelector('[data-list]');
var now = Date.now();
var events = [].slice.call(sec.querySelectorAll('[data-event]')).filter(function (ev) {
var d = ev.dataset.date;
if (!validDate(d)) { if (!sec.hasAttribute('data-design')) ev.remove(); return false; }
var t = parseTime(ev.dataset.time);
ev._start = ptEpoch(d, t[0], t[1]);
ev._end = ptEpoch(nextDay(d), 0, 0);
if (now >= ev._end) { ev.remove(); return false; }
var mon = ev.querySelector('[data-mon]'), day = ev.querySelector('[data-day]'), when = ev.querySelector('[data-when]');
var a = d.split('-');
mon.textContent = label(d, false).split(' ')[0];
day.textContent = String(+a[2]);
when.textContent = label(d, true) + (ev.dataset.time ? ' · ' + ev.dataset.time : '') + (when.dataset.fee ? ' · Entry ' + when.dataset.fee : '');
return true;
});
events.sort(function (a, b) { return a._start - b._start; });
events.forEach(function (ev) { list.appendChild(ev); ev.classList.remove('is-first'); });
var countEl = sec.querySelector('[data-count]');
if (countEl) countEl.textContent = events.length ? events.length + ' upcoming · soonest first' : '';
if (!events.length) { if (!sec.hasAttribute('data-design')) sec.hidden = true; return; }
sec.hidden = false;
events.forEach(function (ev, k) {
var timerBox = ev.querySelector('[data-timer]');
var tLabel = ev.querySelector('[data-timer-label]'), short = ev.querySelector('[data-short]'), slot = ev.querySelector('[data-clock]');
var live = false, gone = false;
if (k === 0) {
ev.classList.add('is-first');
if (Date.now() < ev._start) clock(slot, ev._start, false);
slot.classList.add('rng-pr__clock');
}
var paint = function () {
if (gone) return;
var left = ev._start - Date.now();
if (Date.now() >= ev._end) {
gone = true;
ev.remove();
sec.dataset.rngReady = '';
initPrerelease(sec);
return;
}
if (left <= 0) {
if (live) return;
live = true;
tLabel.textContent = 'Happening now';
short.textContent = 'Live';
if (k === 0) slot.innerHTML = '<p class="rng-hype-live-text">Happening now</p>';
} else {
tLabel.textContent = 'Starts in';
short.textContent = shortLeft(left);
}
};
paint();
ticking.push({ target: ev._end, paint: paint });
if (timerBox) timerBox.hidden = false;
});
}
function init() {
document.querySelectorAll('[data-rng-hc]').forEach(initRotator);
document.querySelectorAll('[data-rng-pr]').forEach(initPrerelease);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', function (e) {
e.target.querySelectorAll('[data-rng-hc]').forEach(initRotator);
e.target.querySelectorAll('[data-rng-pr]').forEach(initPrerelease);
});
})();